export default "__VITE_ASSET__5f52a208__"